import { TrackActionResult } from "../../model/track-action-result";
import { RegistratioData } from "src/app/shared/model/registration-data";
import { TrackInfo } from "../../model/track-info";

export class CompanyAction {

    public static execute(data: RegistratioData): TrackActionResult {
        const id = data.professionalData.originIncome;
        const income: string = data.incomeEquity?.income;
        const patrimony: string = data.incomeEquity?.patrimony;
        const idNotIncome = ['12230', '11841', '11834'];
        const idNotPatrimony = ['11833', '11837', '11840'];
        const filterIdNotIncome = idNotIncome.find(x => x === id);
        const filterIdNotPatrimony = idNotPatrimony.find(x => x === id);

        if (!filterIdNotIncome && (!income || income === '' || income === '0.00') ||
            !filterIdNotPatrimony && (!patrimony || patrimony === '' || patrimony === '0.00')
        ) {
            const trackInfo = new TrackInfo('income-wealthincome', ['income', 'income-wealthincome']);
            return new TrackActionResult(data, trackInfo);
        } else {
            return new TrackActionResult(data, undefined);
        }
    }

}